import { render, staticRenderFns } from "./createQuote.vue?vue&type=template&id=0809aa47&scoped=true&"
import script from "./createQuote.vue?vue&type=script&lang=js&"
export * from "./createQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0809aa47",
  null
  
)

export default component.exports